import {
  Component,
  ViewChild,
  ContentChild,
  Input,
  forwardRef,
  Output,
  EventEmitter,
  ChangeDetectionStrategy,
} from "@angular/core";
import {
  ControlValueAccessor,
  FormControlName,
  NG_VALUE_ACCESSOR,
} from "@angular/forms";
import { MatSnackBar } from "@angular/material/snack-bar";
import { UploadService } from "../../services/upload.service";

@Component({
  selector: "up-image",
  templateUrl: "./image.component.html",
  styleUrls: ["./image.component.scss"],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ImageComponent),
      multi: true,
    },
  ],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class ImageComponent implements ControlValueAccessor {
  isLoading: boolean = false;
  // url: string;

  @ViewChild("fileInput") fileInput: any;
  @ViewChild("menuTrigger") menuTrigger: any;
  @ContentChild(FormControlName) control!: FormControlName;
  @Input() icone = "fal fa-user";
  @Input() value!: string;
  @Input() square: boolean = false;
  //Declara junto com as declarações das variaveis
  @Input() imageSize: number = 5;
  @Input() fluid: boolean = false;
  @Input() isSvg: boolean = false;
  @Input() disabled: boolean = false;

  @Output() uploaded: EventEmitter<boolean>;

  //Declarar o array abaixo
  acceptedFileTypes: string[] = [
    "image/jpeg",
    "image/jpg",
    "image/png",
    "image/bmp",
    "image/gif",
    "image/webp",
  ];

  svgFileTypes: string[] = ["image/svg+xml"];

  constructor(
    private _snackBar: MatSnackBar,
    private _uploadService: UploadService,
  ) {
    this.uploaded = new EventEmitter();
  }

  // Métodos do componente
  changeFile(): void {
    if (!this.isValid()) {
      this.fileInput.nativeElement.click();
    } else {
      setTimeout(() => {
        this.menuTrigger.openMenu();
      }, 100);
    }
  }

  openFile(): void {
    this.fileInput.nativeElement.click();
  }

  removeFile(): void {
    this.value = "";
    // this.url = '';
    this.fileInput.nativeElement.value = null;
    // Propagar a alteração
    this.propagateChange(this.value);
  }

  addFile(): void {
    const fi = this.fileInput.nativeElement;
    if (fi.files && fi.files[0]) {
      const fileToUpload = fi.files[0];
      let acceptedFileTypes = this.isSvg
        ? this.svgFileTypes
        : this.acceptedFileTypes;

      if (fileToUpload.size > this.imageSize * 1000000) {
        this._snackBar.open(
          `O tamanho da imagem excede o limite de ${this.imageSize} Mb.`,
        );
      } else if (acceptedFileTypes.indexOf(fileToUpload.type) == -1) {
        this._snackBar.open("Formato não suportado.");
      } else {
        const reader = new FileReader();
        reader.onload = (event: any) => {
          this.value = <string>reader.result;

          // Propagar para forçar a recarga do componente
          this.propagateChange("defaultImagePropagate");

          this.isLoading = true;
          this.uploaded.emit(this.isLoading);

          let req = this.isSvg
            ? this._uploadService.uploadFile(fileToUpload)
            : this._uploadService.uploadImage(fileToUpload);

          req.subscribe({
            next: (id: string) => {
              this.isLoading = false;
              this.uploaded.emit(this.isLoading);

              // this._snackBar.open('Imagem enviada com sucesso.', 'Fechar');

              // this.url = `${environment.OnStockService}/images/${id}`;
              this.value = id;

              // Propagar a alteração
              this.propagateChange(this.value);
            },
            error: () => {
              this.isLoading = false;
              this.uploaded.emit(this.isLoading);

              this.removeFile();
            },
          });
        };
        reader.readAsDataURL(fileToUpload);
      }
    }
  }

  // Métodos do ValueAccessor
  propagateChange = (_: any) => {};

  writeValue(value: any): void {
    this.value = value;
    // this.url = value;
  }

  registerOnChange(fn: any): void {
    this.propagateChange = fn;
  }

  registerOnTouched(fn: any): void {}

  // Validação do componente
  isValid(): boolean {
    return this.value != null && this.value !== "";
  }

  isRequired(): boolean {
    if (this.control) {
      if (!this.control.errors) {
        return false;
      }
      return this.control.errors["required"];
    }
    return false;
  }
}
